import { render, staticRenderFns } from "./ImageCaptureComponent.vue?vue&type=template&id=c54902f8&scoped=true&"
import script from "./ImageCaptureComponent.vue?vue&type=script&lang=js&"
export * from "./ImageCaptureComponent.vue?vue&type=script&lang=js&"
import style0 from "./ImageCaptureComponent.vue?vue&type=style&index=0&id=c54902f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54902f8",
  null
  
)

export default component.exports